/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ExternalStatus {
    Unknown = 0,
    Ok = 1,
    Misconfigure = 2,
    Unreachable = 3,
}
